{
  "tabs": {
    "chat": "Чат",
    "reminders": "Сануулах",
    "calendar": "Календар",
    "settings": "Тохиргоо"
  },
  "common": {
    "cancel": "Цуцлах",
    "save": "Хадгалах",
    "confirm": "Батлах",
    "delete": "Устгах",
    "back": "Буцах",
    "close": "Хаах",
    "edit": "Засах",
    "search": "Хайх",
    "all": "Бүгд",
    "loading": "Ачааллаж байна...",
    "error": "Алдаа гарлаа",
    "notFound": "Олдсонгүй",
    "tryAgain": "Дахин оролдоно уу",
    "retry": "Дахин оролдох",
    "undo": "Буцаах",
    "pullToRefresh": "Шинэчлэхийн тулд татна уу",
    "justNow": "одоо л"
  },
  "auth": {
    "welcome": "FishMemory-д тавтай морилно уу",
    "tagline": "Таны WhatsApp сануулах туслах, одоо таны халаасанд.",
    "subtitle": "Таны WhatsApp сануулах туслах, одоо таны халаасанд.",
    "phoneLabel": "Таны WhatsApp дугаар",
    "phoneHint": "Бид WhatsApp-аар баталгаажуулах код илгээх болно",
    "invalidPhone": "Зөв дугаар оруулна уу",
    "continue": "Үргэлжлүүлэх",
    "enterPhone": "WhatsApp дугаараа оруулна уу",
    "phonePlaceholder": "Дугаар",
    "sendCode": "Код илгээх",
    "verifyTitle": "Дугаараа баталгаажуулах",
    "otpSentTo": "6 оронтой кодыг {{phone}} дугаарт WhatsApp-аар илгээсэн",
    "enterFullCode": "Бүх 6 орон оруулна уу",
    "invalidOtp": "Буруу код. Дахин оролдоно уу.",
    "otpFailed": "Код илгээхэд алдаа гарлаа. Дахин оролдоно уу.",
    "otpResent": "Код дахин илгээгдлээ",
    "resendIn": "{{seconds}} секундэд дахин илгээх",
    "resendCode": "Код дахин илгээх",
    "enterOtp": "WhatsApp-д ирсэн кодыг оруулна уу",
    "verify": "Батлах",
    "resend": "Код дахин илгээх",
    "wrongNumber": "Буруу дугаар уу?",
    "backToPhone": "Дугаарт буцах",
    "editPhone": "Дугаарыг засах",
    "error": "Алдаа",
    "setupTitle": "Тохиргоог эхлүүлье",
    "setupSubtitle": "Дараа нь Тохиргооноос өөрчлөх боломжтой",
    "namePlaceholder": "Таны нэр",
    "letsGo": "Тохиргоог дуусгах",
    "skipForNow": "Одоохондоо алгасах"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Мессеж бичнэ үү...",
    "inputPlaceholder": "Мессеж бичнэ үү...",
    "typing": "FishMemory бичиж байна...",
    "online": "Онлайн",
    "connecting": "Холбогдож байна...",
    "reconnecting": "Дахин холбогдож байна...",
    "offline": "Салсан",
    "empty": "Яриа эхлүүлэх",
    "emptyHint": "Сануулах үүсгэх, хуваарь шалгах эсвэл тусламж авах.",
    "emptyAction": "Жишээ сануулах илгээх",
    "actions": "Чат үйлдлүүд",
    "keep": "Мессеж хадгалах",
    "clearTitle": "Чатыг цэвэрлэх",
    "clearConfirm": "Энэ төхөөрөмжөөс бүх мессежийг устгах уу? Буцааж сэргээх боломжгүй.",
    "clear": "Чатыг цэвэрлэх",
    "optionSelected": "Сонгогдсон: {{label}}",
    "sendingSelection": "Илгээж байна...",
    "connectionLost": "Дахин холбогдож байна..."
  },
  "reminders": {
    "title": "Миний сануулахууд",
    "active": "Идэвхтэй",
    "today": "Өнөөдөр",
    "thisWeek": "Энэ долоо хоног",
    "history": "Түүх",
    "items": "зүйл",
    "emptyTitle": "Одоогоор сануулах алга",
    "emptySubtitle": "Чатаас үүсгэхэд энд харагдана.",
    "emptyAction": "Чат нээх",
    "filterActive": "Идэвхтэй",
    "filterToday": "Өнөөдөр",
    "filterWeek": "Энэ долоо хоног",
    "filterHistory": "Түүх",
    "emptyState": "Сануулах алга. Яриа эхлүүлээрэй!",
    "swipeDone": "Болсон",
    "swipeSnooze": "Хойшлуулах",
    "swipeDelete": "Устгах",
    "search": "Сануулах хайх...",
    "upcoming": "Удахгүй",
    "completed": "Дууссан",
    "overdue": "Хугацаа хэтэрсэн",
    "tomorrow": "Маргааш",
    "synced": "Синк хийсэн {{value}}",
    "swipeHint": "Илүү үйлдэл хийхийн тулд сануулахыг гүйлгэнэ үү",
    "noResults": "Хайлтанд тохирох сануулах алга",
    "noResultsHint": "Өөр түлхүүр үг туршиж эсвэл хайлтыг цэвэрлэ",
    "deleteAllFailed": "Бүх сануулахыг устгах амжилтгүй боллоо"
  },
  "calendar": {
    "title": "Календар",
    "today": "Өнөөдөр",
    "tomorrow": "Маргааш",
    "completed": "дууссан",
    "noEvents": "Төлөвлөгдсөн зүйл алга",
    "noEventsSubtitle": "Сануулах болон календарын үйл явдлыг харахын тулд огноо сонгоно уу.",
    "googleEvent": "Google Calendar",
    "legendActive": "Идэвхтэй",
    "legendRecurring": "Давтагдах",
    "legendDone": "Дууссан",
    "legendGoogle": "Google",
    "previousMonth": "Өмнөх сар",
    "nextMonth": "Дараагийн сар",
    "previousYear": "Өмнөх жил",
    "nextYear": "Дараагийн жил",
    "goToToday": "Өнөөдөр рүү очих",
    "all": "Бүгд",
    "active": "Идэвхтэй",
    "done": "Дууссан",
    "paused": "Түр зогсоосон"
  },
  "settings": {
    "title": "Тохиргоо",
    "profile": "Профайл",
    "name": "Нэр харуулах",
    "enterName": "Нэрээ оруулна уу",
    "language": "Хэл",
    "uiLanguage": "Апп хэл",
    "uiLanguageHelp": "Зөвхөн энэ төхөөрөмж дээр аппын UI, календарын шошго, байрлалыг өөрчилнө.",
    "serverLanguage": "Чат хэл",
    "serverLanguageHelp": "Таны дансны серверийн хариулт, сануулах мессежийн хэл өөрчлөгдөнө.",
    "timezone": "Цагийн бүс",
    "currentTimezone": "Одоогийн цагийн бүс",
    "timezoneHelp": "Бүх сануулах цаг энэ цагийн бүсээр харуулна.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Цагийн бүс хадгалах",
    "timezoneSaved": "Цагийн бүс шинэчлэгдсэн",
    "detect": "Олох",
    "detectFailed": "Цагийн бүс олдсонгүй",
    "autoDetect": "GPS-аас автоматаар олох",
    "notifications": "Мэдэгдэл",
    "notificationsHelp": "Дараагийн сануулах нь сануулах хүргэгдсэний дараа дахин сэрэмжлүүлгийг хянадаг. Төхөөрөмжийн мэдэгдлийн зөвшөөрлийг утасны тохиргооноос удирдана.",
    "pushEnabled": "Мэдэгдэл идэвхтэй",
    "autoDoneOnFire": "Идэвхжсэн үед автоматаар дуусгах",
    "autoDoneOnFireDesc": "Хаалттай бол сануулахыг та дуусгах хүртэл идэвхтэй байна.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Холбогдсон",
    "googleDisconnected": "Холбогдоогүй",
    "googleConnectedHelp": "Шинэ сануулахуудыг автоматаар календартаа синк хийж болно.",
    "googleDisconnectedHelp": "Google Calendar-тай холбогдож сануулах, үйл явдлыг тааруулна уу.",
    "googleConnectFailed": "Google Calendar холболт амжилтгүй",
    "connected": "Холбогдсон",
    "disconnected": "Холбогдоогүй",
    "connect": "Холбох",
    "disconnect": "Таслах",
    "autoSync": "Шинэ сануулахыг автоматаар синк хийх",
    "autosync": "Шинэ сануулахыг автоматаар синк хийх",
    "subscription": "Үйлчилгээний төлөв",
    "trialUsed": "Туршилт: {{used}}/{{total}} ашигласан",
    "trialStatus": "Туршилт боломжтой",
    "activeStatus": "Идэвхтэй үйлчилгээ",
    "expiredStatus": "Үйлчилгээ дууссан",
    "unsubscribedStatus": "Үйлчилгээ аваагүй",
    "about": "Тухай",
    "version": "Хувилбар",
    "logout": "Гарах",
    "logoutTitle": "Гарах",
    "logoutConfirm": "Гарахдаа итгэлтэй байна уу?",
    "noName": "Нэр тогтоогдоогүй",
    "serverConnection": "Серверийн холболт",
    "serverUrl": "Серверийн URL",
    "serverEdit": "Засах",
    "saveReconnect": "Хадгалах ба дахин холбогдох",
    "resetDefault": "Анхны тохиргоо руу буцах",
    "invalidServerUrlTitle": "Буруу серверийн URL",
    "invalidServerUrlMessage": "Жишээ нь https://example.com гэсэн http эсвэл https серверийн URL оруулна уу",
    "uiLanguageChangeFailed": "Апп хэл солих амжилтгүй боллоо. Дахин оролдоно уу.",
    "serverLanguageChangeFailed": "Чат хэл солих амжилтгүй боллоо. Дахин оролдоно уу.",
    "timezoneChangeFailed": "Цагийн бүс солих амжилтгүй боллоо. Дахин оролдоно уу.",
    "autoSyncChangeFailed": "Автомат синк шинэчлэх амжилтгүй боллоо. Дахин оролдоно уу.",
    "nameChangeFailed": "Нэр шинэчлэх амжилтгүй боллоо. Дахин оролдоно уу.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Сануулах дэлгэрэнгүй",
    "editTime": "Цаг засах",
    "rename": "Нэр өөрчлөх",
    "snooze": "Хойшлуулах",
    "snooze15": "15 минут хойшлуулах",
    "pause": "Түр зогсоох",
    "pauseReminder": "Сануулахыг түр зогсоох",
    "resume": "Дахин эхлүүлэх",
    "resumeReminder": "Сануулахыг дахин эхлүүлэх",
    "skip": "Дараагийнг алгасах",
    "skipOccurrence": "Энэ удаагийнг алгасах",
    "syncGoogle": "Google-тэй синк хийх",
    "delete": "Устгах",
    "deleteTitle": "Сануулахыг устгах",
    "deleteConfirm": "Энэ сануулах байнгын устгагдана.",
    "deleteRecurringTitle": "Давтагдах сануулахыг устгах",
    "deleteRecurringMessage": "Энэ удаагийнг алгасах уу эсвэл бүх цувралыг устгах уу?",
    "deleteThisOccurrence": "Энэ удаагийнг алгасах",
    "deleteEntireSeries": "Бүх цувралыг устгах",
    "done": "Дууссан",
    "markDone": "Дууссан гэж тэмдэглэх",
    "undo": "Буцаах",
    "undoPrompt": "Дахин идэвхтэй болгох уу? Одоо сэргээ.",
    "recurring": "Давтагдах",
    "nextRun": "Дараагийн гүйцэтгэл",
    "oneTime": "Нэг удаагийн",
    "pending": "Хүлээгдэж байна",
    "sent": "Илгээгдсэн",
    "paused": "Түр зогсоосон",
    "active": "Идэвхтэй",
    "snoozed": "Хойшлуулсан",
    "localTime": "Таны орон нутгийн цагт харуулсан",
    "recurrence": "Давтамж",
    "created": "Үүсгэсэн",
    "tags": "Таг",
    "fireCount": "Идэвхжсэн удаа",
    "actions": "Үйлдлүүд",
    "none": "Алга",
    "snoozeFailed": "Хойшлуулах амжилтгүй боллоо",
    "pauseFailed": "Түр зогсоох амжилтгүй боллоо",
    "resumeFailed": "Дахин эхлүүлэх амжилтгүй боллоо",
    "skipFailed": "Алгасах амжилтгүй боллоо",
    "doneFailed": "Дууссан гэж тэмдэглэх амжилтгүй боллоо",
    "undoFailed": "Төлөвийг сэргээх амжилтгүй боллоо",
    "deleteFailed": "Устгах амжилтгүй боллоо",
    "rescheduleTitle": "Дахин товлох уу?",
    "rescheduleMsg": "Энэ сануулах хугацаа хэтэрсэн. Дахин товлох уу?",
    "reschedule15": "15 минутын дараа",
    "reschedule60": "1 цагийн дараа",
    "keepOverdue": "Өмнөх шигээ хадгалах"
  },
  "onboarding": {
    "slide1Title": "FishMemory-д тавтай морилно уу",
    "slide1Sub": "Таны хувийн сануулах туслах — WhatsApp-аар ажилладаг, таны халаасанд зориулсан.",
    "slide2Title": "Зөвхөн байгалийн хэлээр чатла",
    "slide2Sub": "Сануулахыг бодож байгаа шигээ бичээрэй: \"Маргааш 3 цагт ээжид залгахыг сануулна уу\" — бид бусдыг нь зохицуулна.",
    "slide3Title": "Юуг ч бүү мартаарай",
    "slide3Sub": "Цаг тухайд нь мэдэгдэл авч, таг ашиглан зохион байгуулж, чухал бүхнийг хянаарай.",
    "getStarted": "Эхлэх",
    "next": "Дараах",
    "firstReminderTitle": "Анхны сануулахаа үүсгээрэй!",
    "firstReminderHint": "Жишээ бичиж үзээрэй:",
    "firstReminderExample": "Маргааш 9 цагт ус уухыг сануулна уу",
    "gotIt": "Ойлголоо!",
    "notifRationaleTitle": "Цагтаа бай",
    "notifRationaleBody": "FishMemory таныг цагтаа сануулахын тулд мэдэгдэл хэрэгтэй. Зөвхөн таны үүсгэсэн сануулахад мэдэгдэл ирнэ.",
    "notifRationaleAllow": "Мэдэгдэл идэвхжүүлэх",
    "notifRationaleLater": "Дараа нь",
    "swipeHint": "Хурдан үйлдэл хийхийн тулд баруун тийш гүйлгэнэ үү →",
    "calendarDragHint": "Өргөтгөхийн тулд чирнэ үү ↕"
  }
}
